import { render, staticRenderFns } from "./Main_menuPhone_JingPingDengJi.vue?vue&type=template&id=2afa1d8a&scoped=true"
import script from "./Main_menuPhone_JingPingDengJi.vue?vue&type=script&lang=js"
export * from "./Main_menuPhone_JingPingDengJi.vue?vue&type=script&lang=js"
import style1 from "./Main_menuPhone_JingPingDengJi.vue?vue&type=style&index=1&id=2afa1d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa1d8a",
  null
  
)

export default component.exports